import { Api } from "/api";
import { ApiClient } from "/api/client";
import { getCookieDomain } from "/utils";
import { safeSessionStorage } from "/utils/safeStorage";
import Cookies from "js-cookie";

export const getDeliveryCityData = (cityData = {}, reset = false) => {
  return async (dispatch) => {
    let deliveryCityData = {};
    if (reset) {
      deliveryCityData = cityData;
      if (typeof window === "object") {
        const date = new Date();
        date.setTime(date.getTime() + 365 * 24 * 60 * 60 * 1000);
        Cookies.set(
          "deliveryCityData",
          JSON.stringify({
            kladr_id: deliveryCityData.kladr_id,
            postal_code: deliveryCityData.postal_code,
            region_with_type: deliveryCityData.region_with_type,
            region_type_full: deliveryCityData.region_type_full,
            region: deliveryCityData.region,
          }),
          {
            domain: getCookieDomain(),
            path: "/",
            expires: date,
          },
        );
      }
    } else {
      try {
        const deliveryCityDataJson = Cookies.get("deliveryCityData");
        if (deliveryCityDataJson) {
          deliveryCityData = JSON.parse(deliveryCityDataJson);
        }
      } catch (e) {
        console.log("Error getting deliveryCityData", e);
      }
    }

    dispatch({ type: "SET_DELIVERY_CITY_DATA", payload: deliveryCityData });
    dispatch({ type: "SET_DELIVERY_CITY_DATA_LOADED", payload: true });
  };
};

export const setLocation = (cityName) => {
  return async (dispatch) => {
    if (typeof window === "object") {
      const date = new Date();
      date.setTime(date.getTime() + 365 * 24 * 60 * 60 * 1000);
      Cookies.set("cityName", cityName, {
        domain: getCookieDomain(),
        path: "/",
        expires: date,
      });
    }
    dispatch({ type: "SET_CITY_NAME", payload: cityName });
  };
};

export const setCityName = (cityName) => {
  return async (dispatch) => {
    dispatch({ type: "SET_CITY_NAME", payload: cityName });
  };
};

export const setDeliveryCityData = (deliveryCityData) => {
  return async (dispatch) => {
    dispatch({ type: "SET_DELIVERY_CITY_DATA", payload: deliveryCityData });
    dispatch({ type: "SET_DELIVERY_CITY_DATA_LOADED", payload: true });
  };
};

function parseEdostMinDaysCache(raw) {
  if (raw == null || raw === "") {
    return null;
  }
  try {
    const parsed = JSON.parse(raw);
    if (parsed && typeof parsed === "object" && parsed.days != null) {
      return { days: Number(parsed.days) || 0 };
    }
    const days = Number(parsed);
    if (!Number.isNaN(days)) {
      return { days };
    }
  } catch (e) {
    const days = Number(raw);
    if (!Number.isNaN(days)) {
      return { days };
    }
  }
  return null;
}

export const getEdostMinDays = (cityName, region = "", zip = "") => {
  return async (dispatch) => {
    if (cityName) {
      const cacheKey = `edostMinDays:${cityName}:${region || ""}:${zip || ""}`;
      const cached = parseEdostMinDaysCache(
        safeSessionStorage.getItem(cacheKey),
      );
      if (cached) {
        dispatch({ type: "SET_EDOST_MIN_DAYS", payload: cached });
      } else {
        const edostMinDays = await ApiClient.edost.getMinDays(
          cityName,
          region,
          zip,
        );
        if (edostMinDays) {
          dispatch({ type: "SET_EDOST_MIN_DAYS", payload: edostMinDays });
          safeSessionStorage.setItem(cacheKey, JSON.stringify(edostMinDays));
        }
      }
    }
  };
};

export const fetchDomains = () => {
  return async (dispatch) => {
    const domains = await Api.server.getDomains();
    if (!domains) {
      return;
    }
    dispatch({ type: "SET_DOMAINS", payload: domains });
  };
};
